import { Component, OnInit } from '@angular/core';
import {HttpHeaders} from "@angular/common/http";
import {catchError, finalize, throwError} from "rxjs";
import {HttpService} from "../../../services/http.service";
import {UtilService} from "../../../services/util.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-sys-note',
    templateUrl: './sys-note.component.html',
    styleUrls: ['./sys-note.component.scss'],
    standalone: false
})
export class SysNoteComponent implements OnInit {
  saving = false;

  constructor(private httpService : HttpService,
              private util : UtilService,
              private router: Router) { }

  ngOnInit(): void {
  }

  onSendMail(value: any) {
    console.log(value);
    this.saving = true;

    const httpParams =  this.httpService.createHttpParams(value);
    const headers = new HttpHeaders({'Content-Type':  'application/x-www-form-urlencoded'});
    const options = { ...headers };
    return  this.httpService.Post<any>('/notification', httpParams, options).pipe(
      finalize(() => this.saving = false),
      catchError(err => {
        console.log(err);
        return throwError(err);
      })
    ).subscribe(response => {
      console.log(response);
      if (response.errorId) {
        this.util.displayDialogMessage("Error: Email notification error",
          "The email notification for your request was not sent. Try again and if it persists contact support.",
          {subtitle:response.error + ":" + response.errorId});
      } else {
        this.util.displayDialogMessage("Success!", "Notification sent.").subscribe(res => {
          this.router.navigate([this.util.getDashboardURL()] );
        });
      }
    });
  }
}
